export default "__VITE_ASSET__DVGQUNTc__"